import 'bootstrap';
import 'slick-carousel/slick/slick.js';  
import 'jquery-lazy'; 
import 'jquery-lazy/jquery.lazy.plugins.js';
import 'wp-plugins/wpforms-lite/assets/js/wpforms.js'; 
import './vendors/jquery-lazy-mb.js';
import './vendors/equalHeight.min.js';

if (typeof window.wpforms_settings == 'undefined') window.wpforms_settings = "";

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        $.Lazy.media_breakpoints();
        $(".lazy").Lazy();

        if($(window).width() > 540) {
        	$(".video-lazy").Lazy();
        }

        $(".mobile-menu__btn").click(function(){
          $("body").toggleClass("mobile-menu-active");
          $(".mobile-menu").slideToggle(300);
        });

        $(".hero__arrows").click(function(){
          $(this).parents().next('.content-wrapper').addClass('scroll-here');
          $('html, body').animate({
                scrollTop: $('.scroll-here').offset().top
            }, 1500);
        });

        $(".eqHeight").equalHeight({
            perRow: true
        });
      }
    },
    'page_template_page_news': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
      	$("#load-more").click(function() {
      		$(this).remove();
      		$(".load-more-wrapper").removeClass("d-none");
      	});
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
